<div [formGroup]="form" class="d-flex flex-column gap-3">
  <div>
    <mat-checkbox i18n formControlName="other_signed"
      >Notify the signer when a document is signed by another recipient.</mat-checkbox
    >
  </div>
  <div>
    <mat-checkbox i18n formControlName="other_declined"
      >Notify the signer when a document is declined by another recipient.</mat-checkbox
    >
  </div>
  <div>
    <mat-checkbox i18n formControlName="canceled"
      >Notify the signer when a document has been cancelled by the sender.</mat-checkbox
    >
  </div>
  <div>
    <mat-checkbox i18n formControlName="expired">Notify the signer when a document expires.</mat-checkbox>
  </div>
  <div class="d-flex align-items-center gap-2" formGroupName="before_expired">
    <mat-checkbox formControlName="checked" i18n>Notify the signer</mat-checkbox>
    <mat-form-field2 [showLabel]="false" style="width: 10rem">
      <input type="number" matInput formControlName="days" />
      <span matSuffix i18n>Days</span>
    </mat-form-field2>
    <mat-form-field2 [showLabel]="false" style="width: 10rem">
      <input type="number" matInput formControlName="hours" />
      <span matSuffix i18n>Hours</span>
    </mat-form-field2>
    <ng-container i18n>before expiration.</ng-container>
  </div>
  <div class="d-flex align-items-center gap-2" formGroupName="after_expired">
    <mat-checkbox formControlName="checked" i18n>Notify the signer</mat-checkbox>
    <mat-form-field2 [showLabel]="false" style="width: 10rem">
      <input type="number" matInput formControlName="days" />
      <span matSuffix i18n>Days</span>
    </mat-form-field2>
    <mat-form-field2 [showLabel]="false" style="width: 10rem">
      <input type="number" matInput formControlName="hours" />
      <span matSuffix i18n>Hours</span>
    </mat-form-field2>
    <ng-container i18n>after expiration.</ng-container>
  </div>
</div>
